var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"no-capture",rawName:"v-no-capture"}],class:("ckeditor-wrapper " + _vm.theme + "-theme")},[_c('textarea',{staticClass:"d-none",attrs:{"name":"","id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }